import { FC, useMemo } from 'react';
import cn from 'classnames';
import { UiIcon } from '@frontend/znanie-uikit';

import * as DailyQuestionC from '../../DailyQuestion.const';

import * as T from './IconBlock.types';
import css from './IconBlock.module.scss';

export const IconBlock: FC<T.IIconBlock> = (props) => {
  const isResultPage = useMemo(
    () => props.stage === DailyQuestionC.STAGES.RESULTS,
    [props.stage]
  );

  return (
    <div className={css.iconsWrapper}>
      {/* Other pages */}
      <UiIcon
        size={82}
        name="bordered-rhombus"
        color={'rgba(255, 255, 255, 0.3)'}
        className={cn(css.icon, !isResultPage && css.visible)}
      />

      <UiIcon
        size={34}
        name="mark-question"
        color="#FFF"
        className={cn(css.icon, !isResultPage && css.visible)}
      />

      {/* Result page */}
      <UiIcon
        size={82}
        name="bordered-rhombus"
        color={'#fff'}
        className={cn(css.icon, isResultPage && css.visible)}
      />

      <UiIcon
        size={34}
        name={props.isAnswerRight ? 'check-mark-circle-bg' : 'close-circle-bg'}
        color={props.isAnswerRight ? '#93D71F' : '#F0304E'}
        className={cn(css.icon, isResultPage && css.visible)}
      />
    </div>
  );
};
